module.exports = __webpack_public_path__ + "img/havefun_kansai_kr.9c767e5b.png";